import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=f7f23368&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=f7f23368&prod&scoped=true&lang=scss"
import style1 from "./Detail.vue?vue&type=style&index=1&id=f7f23368&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f23368",
  null
  
)

export default component.exports